var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudienceFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7351_19479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9448 40H11.156C7.75958 40 5 37.2718 5 33.914V6.08605C5 2.72823 7.75958 0 11.156 0H26.6098L35.1008 8.43653V33.914C35.1008 37.2718 32.341 40 28.9448 40Z",
    fill: "#00AC54"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.1082 8.43653H28.3579C27.3814 8.43653 26.6172 7.681 26.6172 6.71563V0",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8192 28.2955C28.8192 28.7787 28.4275 29.1705 27.9442 29.1705H12.1602C11.6769 29.1705 11.2852 28.7787 11.2852 28.2955V16.6562C11.2852 16.173 11.6769 15.7812 12.1602 15.7812H27.9442C28.4275 15.7812 28.8192 16.173 28.8192 16.6562V28.2955Z",
    stroke: "white",
    strokeWidth: 1.10178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2832 15.7812V29.1705",
    stroke: "white",
    strokeWidth: 1.10178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2852 25.3516H28.8192",
    stroke: "white",
    strokeWidth: 1.10178
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2852 20.145H28.8192",
    stroke: "white",
    strokeWidth: 1.10178
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7351_19479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceFile);
export default __webpack_public_path__ + "static/media/AudienceFile.0a60fd1cc182aa55bb8dbc3a26a0e4eb.svg";
export { ForwardRef as ReactComponent };